import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import WithLoadingHandler from './hoc/withLoadingHandler/withLoadingHandler';
import { BrowserRouter } from 'react-router-dom';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { EventType, InteractionType } from '@azure/msal-browser';
import { Provider } from 'react-redux';
import { UserProvider } from 'context/User/UserProvider';
import { LoginPolicyGate } from 'components/layouts/LoginPolicyGate';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.css';

import msalInstance from './services/msal/msal';
import msalConfig from './services/msal/config';
import store from './store/config/configureStore';

/**
 * Attach high-priority event callback for managing active account.
 */
msalInstance.addEventCallback(event => {
	switch (event.eventType) {
		// entering site
		case EventType.LOGIN_SUCCESS:
			msalInstance.setActiveAccount(event.payload?.account);
			break;
		// leaving site
		case EventType.LOGOUT_SUCCESS:
			msalInstance.setActiveAccount(null);
			break;
		default:
			break;
	}
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<BrowserRouter>
			<MsalProvider instance={msalInstance}>
				<MsalAuthenticationTemplate
					authenticationRequest={msalConfig.requests.api}
					interactionType={InteractionType.Redirect}
					loadingComponent={() => (
						<WithLoadingHandler
							isLoading={true}
							showChildren={false}
						/>
					)}
				>
					<UserProvider>
						<LoginPolicyGate>
							<App />
                        </LoginPolicyGate>
					</UserProvider>
				</MsalAuthenticationTemplate>
			</MsalProvider>
		</BrowserRouter>
	</Provider>
);
